import React, { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import * as Yup from 'yup';
import { Button, FormInput, Row, FormSelect, FormSubmitButton, MasterDetailForm, } from '@digital/ui';
import { UploadFile, Visibility } from '@app/components';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, updateParecerDPC } from '@app/api/sas/sasProposta';
import { useRecoilState, useRecoilValue } from 'recoil';
import { editandoState, modalAcoesIdState, reloadVendorListState, vendorListDocsState } from '../atoms';
import { IArquivo } from '@app/types/core.types';
import { isObjEmpty, isObjNotEmpty } from '@app/helpers/objHelper';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';

interface Props {
  sasProposta: ISasPropostaOrdemCompra;
}

const { confirm } = Modal;

const ModalParecerDPC = ({ sasProposta }: Props) => {
  const [exibirModal, setExibirModal] = useState(false);
  const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
  const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);
  const [editando, setEditando] = useRecoilState(editandoState);

  const options = [
    { value: 'Favorável', text: 'Favorável' },
    { value: 'Desfavorável', text: 'Desfavorável' },
    { value: 'Favorável Condicional', text: 'Favorável Condicional' }
  ];

  const vendorListDocs = useRecoilValue(vendorListDocsState);
  const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

  useEffect(() => {
    var doc = vendorListDocs.find(f => f.id == sasProposta.id);
    if (isObjNotEmpty(doc)) {
      setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
    }
  }, [exibirModal]);

  const handleCancel = () => {
    setModalAcoesId('');
    setExibirModal(false);
  };

  const handleSubmit = (values: any) => {
    const form = new FormData();
    form.append('sasPropostaId', sasProposta.id);
    form.append('anexo', values.arquivo);
    form.append('resultadoParecerDPC', values.resultadoParecerDPC);

    Modal.confirm({
      title: 'Envio do Parecer do DPC',
      content: `Confirma o envio do Parecer do DPC?`,
      cancelText: 'Cancelar',
      onCancel: () => { },
      okText: 'Confirmar',
      onOk: () => {

        if (editando.sasPropostaId == sasProposta.id) {
          Modal.confirm({
            title: <>{editando.justificativa}</>,
            content: <ModalConfirmContentJustificativa
              texto='É necessário informar a justificativa para a alteração.'
              setJustificativa={e => {
                form.set('justificativaEdicao', e);
              }}
            />,
            okText: 'Confirmar',
            cancelText: 'Cancelar',
            onOk: async (e) => {
              form.append('editando', 'true');
              return new Promise((resolve, reject) => {
                updateParecerDPC(form)
                  .then((data: any) => {
                    if (data && data.valid) {
                      setReloadVendorList(!reloadVendorList);
                      handleCancel();
                      return resolve(true);
                    } else {
                      if (data.notifications && data.notifications.length > 0) {
                        const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                          return c.property == 'justificativaEdicao';
                        });
                        if (erroJustificativaEdicao >= 0) {
                          return reject(false);
                        }
                      }
                    }
                  });
              });
            },
            onCancel: () => { setModalAcoesId(''); }
          });
        } else {

          updateParecerDPC(form)
            .then((data: any) => {
              if (data && data.valid) {
                setReloadVendorList(!reloadVendorList);
                handleCancel();
              }
            });
        }
      }
    });
  };


  return (
    <>
      <Tooltip title='Parecer DPC' >
        <Button icon='business-documents' onClick={() => { setExibirModal(true); }} />
      </Tooltip>

      <Visibility
        visible={exibirModal}
      >
        <Modal title="Parecer DPC" width="680px" visible={exibirModal} onCancel={handleCancel} footer={null}>
          <MasterDetailForm
            actions={[
              <Button title='fechar' type='link' onClick={() => handleCancel()} />,
              <Visibility visible={isObjEmpty(sasProposta.resultadoParecerDPC) || sasProposta.resultadoParecerDPC == "Pendente"}>
                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
              </Visibility>
            ]}
            initialValues={sasProposta}
            validationSchema={Yup.object().shape({
              arquivo: isObjNotEmpty(doc) && doc.anexoParecerDPC ? Yup.mixed().notRequired() : Yup.mixed().required('É necessário anexar um arquivo.'),
              resultadoParecerDPC: Yup.string().required(`O campo Resultado é obrigatório.`)
            })
            }
          >
            <Row>
              <FormInput label="Status do Recebimento"
                name="statusRecebimento"
                value={sasProposta.statusParecerDPC || "Pendente"}
                span={6}
                disabled
              />
              <FormSelect
                label="Resultado"
                placeholder="Selecione uma opção"
                required
                options={options}
                name="resultadoParecerDPC"
                span={6}
                disabled={
                  isObjNotEmpty(sasProposta.resultadoParecerDPC) &&
                  editando.sasPropostaId !== sasProposta.id
                }
              />
            </Row>
            <Row>
              <UploadFile
                idDoComponente='fileEnvioDdi'
                type='primary'
                onGetArquivo={() => {

                  if (isObjNotEmpty(doc.anexoParecerDPC)) {
                    return Promise.resolve({
                      id: doc.anexoParecerDPC.id,
                      nome: doc.anexoParecerDPC.nome,
                      status: "",
                      statusArquivoId: doc.anexoParecerDPC.statusArquivoId || "",
                    } as IArquivo);
                  }
                  return Promise.resolve(undefined);
                }}
                showDownload={true}
                span={6}
              />
            </Row>
          </MasterDetailForm>
        </Modal>
      </Visibility>
    </>
  );
};
export default ModalParecerDPC;
